import { Navigate, useLocation, useParams } from 'react-router';

// Old addresses kept working after pages moved. Each keeps the query string, so a deep
// link into a category or a page of results lands where it pointed.

/** Ticket Categorization lives on the Protocols page now, in the drafts view. */
export default function TicketCategorization() {
  return <Navigate to='/training/protocols?view=drafts' replace />;
}

/** Sources moved inside Training. */
export function SourcesRedirect() {
  const { search } = useLocation();
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/training/sources${id ? `/${id}` : ''}${search}`} replace />;
}
